import { EventEmitter, SimpleChanges } from '@angular/core';
import { Store } from '@ngrx/store';
import { catchError, tap, throwError } from 'rxjs';
import uuid from 'uuid-random';
import { addAutocompleterId, resetAutocompleter, } from 'SearchApp/ts/features/base-autocomplete/state/autocompleter.actions';
import { AUTOCOMPLETER_STATE_SLICE_KEY } from 'SearchApp/ts/features/base-autocomplete/state/autocompleter.reducer';
import { TAB_ACTIVE_USER_CHANNEL } from 'Angular/features/components/navigation/constants';
import { PRO_ADMIN_TIER } from 'Angular/features/components/navigation/top-bar-nav/constants';
import { ImpersonationService } from 'AccountsApp/ts/services/impersonation.service';
import { RefreshRequiredModalComponent } from 'Angular/features/components/modals/refresh-required-modal/refresh-required-modal.component';
import { abbreviateUserDisplayName } from 'Angular/features/components/navigation/utils';
import * as i0 from "@angular/core";
import * as i1 from "AccountsApp/ts/services/impersonation.service";
import * as i2 from "@ngrx/store";
import * as i3 from "../../../../../../../apps/search/static/search/ts/features/base-autocomplete/components/search-bar.component";
import * as i4 from "@angular/common";
import * as i5 from "../../modals/refresh-required-modal/refresh-required-modal.component";
import * as i6 from "../../loaders/loading-symbol/loading-symbol.component";
import * as i7 from "Angular/features/components/navigation/impersonation-target-user-list/impersonation-target-user-list.component";
const _c0 = ["refreshRequiredModal"];
const _c1 = (a0, a1) => ({ "active": a0, "show": a1 });
const _c2 = a0 => ({ "collapse": a0 });
const _c3 = () => [];
function ImpersonationMenuComponent_Conditional_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "ycn-loading-symbol");
} }
function ImpersonationMenuComponent_Conditional_5_Conditional_12_Template(rf, ctx) { if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 16);
    i0.ɵɵlistener("mouseleave", function ImpersonationMenuComponent_Conditional_5_Conditional_12_Template_div_mouseleave_0_listener() { i0.ɵɵrestoreView(_r4); const ctx_r2 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r2.setTargetUserMenuExpanded(false)); });
    i0.ɵɵelementStart(1, "div", 17)(2, "ycn-search-bar", 18);
    i0.ɵɵlistener("searchBarBlurHandler", function ImpersonationMenuComponent_Conditional_5_Conditional_12_Template_ycn_search_bar_searchBarBlurHandler_2_listener() { i0.ɵɵrestoreView(_r4); const ctx_r2 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r2.resetAutocompleter()); });
    i0.ɵɵelementEnd()();
    i0.ɵɵelement(3, "div", 19);
    i0.ɵɵelementStart(4, "ycn-impersonation-target-user-list", 20);
    i0.ɵɵlistener("setCurrentTargetUserHandler", function ImpersonationMenuComponent_Conditional_5_Conditional_12_Template_ycn_impersonation_target_user_list_setCurrentTargetUserHandler_4_listener($event) { i0.ɵɵrestoreView(_r4); const ctx_r2 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r2.setCurrentTargetUser($event)); });
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("autocompleterId", ctx_r2.autocompleterId)("searchType", "user_impersonation_permission")("placeholder", "Search Team Member")("includeSearchIcon", true)("hideButton", true);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("autocompleterId", ctx_r2.autocompleterId)("initialTargetUserList", ctx_r2.targetUsers || i0.ɵɵpureFunction0(8, _c3))("currentTargetUser", ctx_r2.currentTargetUser);
} }
function ImpersonationMenuComponent_Conditional_5_Template(rf, ctx) { if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 4)(1, "label", 6)(2, "div", 7)(3, "div", 8);
    i0.ɵɵtext(4, "Work as");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(5, "label", 9)(6, "input", 10);
    i0.ɵɵlistener("click", function ImpersonationMenuComponent_Conditional_5_Template_input_click_6_listener($event) { i0.ɵɵrestoreView(_r2); const ctx_r2 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r2.toggleWorkAs($event)); });
    i0.ɵɵelementEnd();
    i0.ɵɵelement(7, "span", 11);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(8, "div", 12)(9, "div", 13);
    i0.ɵɵlistener("click", function ImpersonationMenuComponent_Conditional_5_Template_div_click_9_listener() { i0.ɵɵrestoreView(_r2); const ctx_r2 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r2.setTargetUserMenuExpanded(!ctx_r2.targetUserMenuExpanded)); });
    i0.ɵɵelementStart(10, "span", 14);
    i0.ɵɵtext(11);
    i0.ɵɵelementEnd()();
    i0.ɵɵconditionalCreate(12, ImpersonationMenuComponent_Conditional_5_Conditional_12_Template, 5, 9, "div", 15);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(4, _c2, !ctx_r2.expanded));
    i0.ɵɵadvance(6);
    i0.ɵɵproperty("checked", ctx_r2.workAsActive);
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate1(" ", ctx_r2.getUserDisplayName(ctx_r2.currentTargetUser), " ");
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r2.targetUserMenuExpanded ? 12 : -1);
} }
/**
 * Impersonation Menu Component (in the nav bar)
 *
 * Responsible for:
 * - toggling impersonation on and off
 * - selecting current target user
 * - managing the impersonation target search autocompleter.
 */
export class ImpersonationMenuComponent {
    constructor(impersonationService, store) {
        this.impersonationService = impersonationService;
        this.store = store;
        this.userMenuActive = false;
        this.addErrorMessageHandler = new EventEmitter();
        this.DEFAULT_ERROR_MESSAGE = 'An unknown error occurred. Please try again or contact support.';
        this.loading = false;
        this.expanded = false;
        this.targetUserMenuExpanded = false;
        this.targetUsers = null;
        this.currentTargetUser = null;
        this.workAsActive = false;
        this.broadcastChannel = new BroadcastChannel(TAB_ACTIVE_USER_CHANNEL);
        this.mapStateToComponent = (state) => {
            const { selectedResult } = state[this.autocompleterId];
            if (selectedResult) {
                this.resetAutocompleter();
            }
        };
        this.workAsActive = window.USER.impersonationState.userImpersonating;
        // expand Impersonation menu if active impersonation or user is on PRO_ADMIN tier (impersonation only)
        if (this.workAsActive || window.USER.tierInternalName === PRO_ADMIN_TIER) {
            this.toggleExpanded();
        }
        // Listen for changes to the active user in other tabs.
        this.broadcastChannel.addEventListener('message', (event) => {
            if (event.data !== window.USER.email) {
                // Open the modal if the new active user is different from the current user
                this.refreshRequiredModal.openModal();
            }
            else {
                // Close the modal if the active user is different from the current user
                this.refreshRequiredModal.closeModal();
            }
        });
        // initialize autocompleterId
        this.autocompleterId = uuid();
        this.store.dispatch(addAutocompleterId({ autocompleterId: this.autocompleterId }));
        this.storeSubscription = this.store.select(AUTOCOMPLETER_STATE_SLICE_KEY).subscribe(this.mapStateToComponent);
    }
    ngOnChanges(changes) {
        if (changes.userMenuActive && changes.userMenuActive.currentValue === false) {
            this.targetUserMenuExpanded = false;
        }
    }
    ngOnDestroy() {
        this.storeSubscription.unsubscribe();
        this.broadcastChannel.close();
    }
    resetAutocompleter() {
        this.store.dispatch(resetAutocompleter({ autocompleterId: this.autocompleterId }));
    }
    toggleExpanded() {
        // On the first expansion, fetch the target users for the menu. We do this on first
        // expansion rather than on component initialization to avoid making this call on every page.
        if (this.targetUsers === null) {
            this.loading = true;
            this.impersonationService.getImpersonationMenu().subscribe((response) => {
                this.targetUsers = response;
                this.currentTargetUser = response.length > 0 ? response[0] : null;
                this.loading = false;
            });
        }
        this.expanded = !this.expanded;
    }
    toggleWorkAs(toggleEvent) {
        // set loading immediately to prevent multiple clicks
        this.loading = true;
        const input = toggleEvent.target;
        this.workAsActive = input.checked;
        if (!this.workAsActive) {
            // Turning OFF - end impersonation
            this.impersonationService.endImpersonation().subscribe({
                next: (response) => {
                    // Successfully ended impersonation
                    this.broadcastChannel.postMessage(response.body.active_user_email);
                    window.location.reload();
                },
                error: () => {
                    this.loading = false;
                    // If an error occurs while ending impersonation, logout to flush the session
                    window.location.href = `/logout?next=${window.location.pathname}`;
                },
            });
        }
        else {
            // Turning ON - start impersonation
            if (this.currentTargetUser === null) {
                this.addErrorMessageHandler.emit('No user selected for impersonation.');
                this.workAsActive = false;
                input.checked = false;
                this.loading = false;
                return;
            }
            this.impersonateCurrentTargetUser().subscribe({
                next: () => { },
                error: () => {
                    this.workAsActive = false;
                    input.checked = false;
                },
            });
        }
    }
    setTargetUserMenuExpanded(expanded) {
        this.targetUserMenuExpanded = expanded;
    }
    setCurrentTargetUser(user) {
        if (this.currentTargetUser && this.currentTargetUser.email === user.email)
            return;
        // set as current target user
        const previousTargetUser = this.currentTargetUser;
        this.currentTargetUser = user;
        // add user to targetUsers if not already present
        const targetUsers = this.targetUsers || [];
        if (!targetUsers.some((u) => u.email === this.currentTargetUser.email)) {
            this.targetUsers = [this.currentTargetUser, ...targetUsers];
        }
        // if currently impersonating, setting a new target user should trigger request to impersonate new user
        if (this.workAsActive) {
            this.impersonateCurrentTargetUser().subscribe({
                next: () => { },
                error: () => {
                    this.currentTargetUser = previousTargetUser;
                },
            });
        }
    }
    getUserDisplayName(user) {
        if (user === null) {
            return '--';
        }
        return abbreviateUserDisplayName(user.first_name, user.last_name, 15);
    }
    impersonateCurrentTargetUser() {
        this.loading = true;
        return this.impersonationService.impersonateUser(this.currentTargetUser.email).pipe(tap((response) => {
            // Successfully started impersonation
            this.broadcastChannel.postMessage(response.body.active_user_email);
            window.location.reload();
        }), catchError((response) => {
            this.loading = false;
            this.addErrorMessageHandler.emit(response.error.error || this.DEFAULT_ERROR_MESSAGE);
            return throwError(() => response);
        }));
    }
}
ImpersonationMenuComponent.ɵfac = function ImpersonationMenuComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || ImpersonationMenuComponent)(i0.ɵɵdirectiveInject(i1.ImpersonationService), i0.ɵɵdirectiveInject(i2.Store)); };
ImpersonationMenuComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ImpersonationMenuComponent, selectors: [["ycn-impersonation-menu"]], viewQuery: function ImpersonationMenuComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.refreshRequiredModal = _t.first);
    } }, inputs: { userMenuActive: "userMenuActive" }, outputs: { addErrorMessageHandler: "addErrorMessageHandler" }, standalone: false, features: [i0.ɵɵNgOnChangesFeature], decls: 8, vars: 6, consts: [["refreshRequiredModal", ""], [1, "collapse-wrap"], [1, "collapse-header", 3, "click", "ngClass"], [1, "caret"], [1, "theme-dark", "pb-2", 3, "ngClass"], [3, "refreshMessage"], [1, "d-flex", "align-items-center", "mt-1", "mb-10", "pl-20", "pr-20"], [1, "form-label", "form-label-thin"], [1, "text-white", "mr-1"], [1, "custom-control", "custom-switch"], ["type", "checkbox", 1, "custom-control-input", 3, "click", "checked"], [1, "custom-control-indicator"], [1, "dropdown", "ml-20", "mr-20"], [1, "btn", "btn-block", "btn-outline", "btn-white", 3, "click"], [1, "d-flex", "align-items-center", "justify-content-between", "w-full", "text-default", "text-nowrap", "caret"], [1, "dropdown-menu", "dropdown-menu-right", "dropdown-menu-with-icons", "width-260", "d-block"], [1, "dropdown-menu", "dropdown-menu-right", "dropdown-menu-with-icons", "width-260", "d-block", 3, "mouseleave"], [1, "ml-12", "mr-12", "pt-1", "pb-1", "theme-dark"], [1, "input-group", "field-input-group", 3, "searchBarBlurHandler", "autocompleterId", "searchType", "placeholder", "includeSearchIcon", "hideButton"], [1, "dropdown-divider"], [3, "setCurrentTargetUserHandler", "autocompleterId", "initialTargetUserList", "currentTargetUser"]], template: function ImpersonationMenuComponent_Template(rf, ctx) { if (rf & 1) {
        const _r1 = i0.ɵɵgetCurrentView();
        i0.ɵɵelementStart(0, "div", 1)(1, "div", 2);
        i0.ɵɵlistener("click", function ImpersonationMenuComponent_Template_div_click_1_listener() { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.toggleExpanded()); });
        i0.ɵɵelementStart(2, "div", 3);
        i0.ɵɵtext(3, "Impersonate");
        i0.ɵɵelementEnd()();
        i0.ɵɵconditionalCreate(4, ImpersonationMenuComponent_Conditional_4_Template, 1, 0, "ycn-loading-symbol")(5, ImpersonationMenuComponent_Conditional_5_Template, 13, 6, "div", 4);
        i0.ɵɵelementEnd();
        i0.ɵɵelement(6, "ycn-refresh-required-modal", 5, 0);
    } if (rf & 2) {
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(3, _c1, ctx.expanded, ctx.expanded));
        i0.ɵɵadvance(3);
        i0.ɵɵconditional(ctx.loading ? 4 : 5);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("refreshMessage", "The active user for this tab has changed. Please refresh the page to continue.");
    } }, dependencies: [i3.SearchBarComponent, i4.NgClass, i5.RefreshRequiredModalComponent, i6.LoadingSymbolComponent, i7.ImpersonationTargetUserListComponent], encapsulation: 2 });
